import { notificationsClient } from "@core/clients";
import { NotificationTypeItem } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { NOTIFICATION_TYPES_CACHE_EXPIRE_TIME_MS, NOTIFICATION_TYPES_STALE_TIME_MS } from "../../config/constansts";

type QueryParams = {
  customerId?: string;
  isPublicOnly?: boolean;
};

type Options = UseQueryOptions<NotificationTypeItem[], any>;

const useGetNotificationTypesQuery = (config: { options?: Options; params?: QueryParams } = {}) => {
  return useQuery<NotificationTypeItem[], any>(
    ["notification-types", config.params?.customerId, config.params?.isPublicOnly],

    async () => {
      return await notificationsClient.getNotificationTypes(config.params);
    },

    {
      cacheTime: NOTIFICATION_TYPES_CACHE_EXPIRE_TIME_MS,
      staleTime: NOTIFICATION_TYPES_STALE_TIME_MS,
      ...config.options,
    },
  );
};

export default useGetNotificationTypesQuery;
